<template>
  <v-dialog
    :value="value"
    max-width="520"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="pa-4 pa-md-5 align-start">
        <div>
          <div class="text-h6 font-weight-bold text-typo">
            {{ $t("Onde_deseja_pesquisar") }}
          </div>
          <div class="text-body-2 text--secondary font-weight-regular">
            {{ $t("Selecione_o_campo_que_deve_receber_o_foco") }}
          </div>
        </div>
        <v-spacer />
        <v-btn
          ref="closeButton"
          icon
          :aria-label="$t('Fechar')"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-3 pa-md-4">
        <v-btn
          v-for="(field, index) in fields"
          :key="field.id"
          :ref="`fieldButton${index}`"
          block
          text
          color="primary"
          class="crud-search-field-option justify-start text-none mb-1"
          @click="selectField(field.id)"
        >
          <v-icon left small>mdi-magnify</v-icon>
          <span class="text-body-2 text-typo">{{ field.label }}</span>
        </v-btn>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text class="text-none" @click="$emit('input', false)">
          {{ $t("Cancelar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  consumeKeyboardEvent,
  getTopActiveDialog,
  trapTabWithin,
} from "@/utils/crudKeyboard";

export default {
  name: "CrudSearchFieldDialog",
  props: {
    value: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] },
  },
  data() {
    return {
      previouslyFocused: null,
      selecting: false,
    };
  },
  watch: {
    value(open) {
      if (open) {
        this.previouslyFocused = document.activeElement;
        this.selecting = false;
        this.$nextTick(this.focusFirstField);
        return;
      }

      if (!this.selecting) this.restorePreviousFocus();
      this.selecting = false;
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleDialogKeydown, true);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleDialogKeydown, true);
  },
  methods: {
    focusFirstField() {
      const reference = this.$refs.fieldButton0;
      const button = Array.isArray(reference) ? reference[0] : reference;
      const element = button?.$el || button;
      element?.focus?.();
    },
    restorePreviousFocus() {
      const element = this.previouslyFocused;
      this.$nextTick(() => {
        if (element?.isConnected) element.focus?.();
      });
    },
    selectField(fieldId) {
      this.selecting = true;
      this.$emit("select", fieldId);
      this.$emit("input", false);
    },
    handleDialogKeydown(event) {
      if (!this.value) return;
      const dialog = getTopActiveDialog(this.$el?.ownerDocument);
      if (!dialog) return;

      if (event.key === "Tab") {
        trapTabWithin(dialog, event);
        return;
      }
      if (event.key === "Escape" || event.key === "Esc") {
        consumeKeyboardEvent(event, true);
        this.$emit("input", false);
      }
    },
  },
};
</script>

<style scoped>
.crud-search-field-option {
  min-height: 44px;
  white-space: normal;
}
</style>
